"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseApi_1 = __importDefault(require("./BaseApi"));
const BaseSignupsApiPath = "/shop/api/v1/signups";
class SignupsApi extends BaseApi_1.default {
    validateEmail(email) {
        return this.http.get(`${BaseSignupsApiPath}/validate_email/?email=${email}`);
    }
    createSignup(data) {
        return this.http.post(`${BaseSignupsApiPath}/`, data);
    }
    fetchSignup(id) {
        return this.http.get(`${BaseSignupsApiPath}/${id}/`);
    }
}
exports.default = SignupsApi;
